import {
  AlternativePaymentMethod,
  MilesPayment,
  PaymentCard,
  PaymentMethod,
} from '@dapi/sdk';
import {
  createPaymentCard,
  MockPaymentCard,
} from '@dapi/sdk/spec';

export const paymentRecordId = '1234560027186804';

export const paymentCard: MockPaymentCard = createPaymentCard({
  template: {
    cardNumber: 'XXXXXXXXXXXX9999',
    expiryDate: '1028',
    id: '1234560027186804',
    paymentType: 'PaymentCard',
    vendorCode: 'VI'
  }
});

export const paymentCardCA: MockPaymentCard = createPaymentCard({
  template: {
    cardNumber: 'XXXXXXXXXXXX1096',
    expiryDate: '0525',
    id: 'CC',
    paymentType: 'PaymentCard',
    vendorCode: 'CA'
  }
});

export const paymentMethod: PaymentCard = {
  paymentType: 'PaymentCard',
  cardNumber: 'XXXXXXXXXXXX1096'
};

export const payPalPayment: AlternativePaymentMethod = {
  id: 'LHAMPPP',
  name: 'PayPal',
  paymentType: 'AlternativePaymentMethod',
  status: 'approved'
};

export const voucherPayment: AlternativePaymentMethod = {
  id: 'XXXXXXXXX8333',
  paymentType: 'VoucherPayment'
};

export const voucherPaymentWithIdVoucher: AlternativePaymentMethod = {
  id: '0982167479759-VOUCHER',
  paymentType: 'VoucherPayment'
};

export const voucherPayment2: AlternativePaymentMethod = {
  id: 'XXXXXXXXX8335',
  paymentType: 'VoucherPayment'
};

export const voucherPayment3: AlternativePaymentMethod = {
  id: 'XXXXXXXXX8338',
  paymentType: 'VoucherPayment'
};

export const customPaymentMethod: AlternativePaymentMethod = {
  id: '1172457148333',
  paymentType: 'VoucherPayment'
};

export const alternativePaymentMethod: PaymentMethod = {
  id: 'LHAMPSO',
  paymentType: 'AlternativePaymentMethod'
};

export const milesPaymentMethod: MilesPayment = {
  paymentType: 'MilesPayment',
  companyCode: 'LH',
  cardNumber: '222012009749273'
};
